export function isProd() {
    return process.env.NEXT_PUBLIC_APP_ENV === 'prod';
}
